<template>
  <form @submit.prevent>
    <div>
      <h2>
        {{ $t("asset-group.edit-dimension") }}
      </h2>

      <label class="mt-4"
        >{{ $t("asset-group-survey.assesment-criterias.privacy") }} <i id="popover-privacy" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i
      ></label>
      <!--TODO  popoverlar component galine getirilmeli tekrarlı kullanım söz konusu  -->
      <b-popover container="popover-info" custom-class="wide-popover" target="popover-privacy" triggers="hover focus" placement="left">
        <!-- <template #title>İstatistikler</template> -->
        <table class="table mb-0">
          <thead>
            <tr>
              <th>{{ $t("asset-group.info.privacy.h1") }}</th>
              <th>{{ $t("asset-group.info.privacy.h2") }}</th>
              <th>{{ $t("asset-group.info.privacy.h3") }}</th>
              <th>{{ $t("asset-group.info.privacy.h4") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p class="mb-1">{{ $t("asset-group-survey.assesment-criterias.privacy") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.privacy.p1") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.privacy.p2") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.privacy.p3") }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </b-popover>
      <select v-model.number="form.assesmentCriterias.privacy" class="form-control">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="3">3</option>
      </select>

      <label class="mt-4"
        >{{ $t("asset-group-survey.assesment-criterias.entirety") }}
        <i id="popover-entirety" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
      </label>
      <select v-model.number="form.assesmentCriterias.entirety" class="form-control">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="3">3</option>
      </select>

      <b-popover container="popover-info" custom-class="wide-popover" target="popover-entirety" triggers="hover focus" placement="left">
        <!-- <template #title>İstatistikler</template> -->
        <table class="table mb-0">
          <thead>
            <tr>
              <th>{{ $t("asset-group.info.entirety.h1") }}</th>
              <th>{{ $t("asset-group.info.entirety.h2") }}</th>
              <th>{{ $t("asset-group.info.entirety.h3") }}</th>
              <th>{{ $t("asset-group.info.entirety.h4") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p class="mb-1">{{ $t("asset-group-survey.assesment-criterias.entirety") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.entirety.p1") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.entirety.p2") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.entirety.p3") }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </b-popover>

      <label class="mt-4"
        >{{ $t("asset-group-survey.assesment-criterias.accessibility") }}
        <i id="popover-accessibility" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
      </label>
      <select v-model.number="form.assesmentCriterias.accessibility" class="form-control">
        <option :value="1">1</option>
        <option :value="2">2</option>
        <option :value="3">3</option>
      </select>

      <b-popover container="popover-info" custom-class="wide-popover" target="popover-accessibility" triggers="hover focus" placement="left">
        <!-- <template #title>İstatistikler</template> -->
        <table class="table mb-0">
          <thead>
            <tr>
              <th>{{ $t("asset-group.info.accessibility.h1") }}</th>
              <th>{{ $t("asset-group.info.accessibility.h2") }}</th>
              <th>{{ $t("asset-group.info.accessibility.h3") }}</th>
              <th>{{ $t("asset-group.info.accessibility.h4") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.accessibility.p0") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.accessibility.p1") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.accessibility.p2") }}</p>
              </td>
              <td>
                <p class="mb-1">{{ $t("asset-group.info.accessibility.p3") }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </b-popover>
      <br />
      <br />

      <sweet-textarea
        v-model="form.description"
        :isValid="!$v.form.description.$error"
        @input="$v.form.description.$touch()"
        type="text"
        layout="vertical"
        :placeholder="$t('common.description')"
        :label="$t('asset-group.description')"
        :rows="9"
      />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { maxLength, maxValue, minLength, minValue, required } from "vuelidate/lib/validators";

const state = "organizationAssetGroup";
const assesmentCriterias = { privacy: undefined, entirety: undefined, accessibility: undefined };
export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  components: {
    SweetTextarea,
  },
  data() {
    return {
      form: { assesmentCriterias, description: undefined },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      assesmentCriterias: {
        privacy: {
          minValue: minValue(0),
          maxValue: maxValue(3),
        },
        entirety: {
          minValue: minValue(0),
          maxValue: maxValue(3),
        },
        accessibility: {
          minValue: minValue(0),
          maxValue: maxValue(3),
        },
      },
      description: {
        maxLength: maxLength(350),
      },
      assetGroupCategory: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.form = { assesmentCriterias, ...this.prepareFormForEdit(JSON.parse(JSON.stringify(v))) };
        }
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { privacy, entirety, accessibility } = this.form.assesmentCriterias;
        this.form.criticalityLevel = Math.max(privacy || 0, entirety || 0, accessibility || 0);

        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.$toast.success(this.$t("common.success"));

        this.$root.$emit("bv::toggle::collapse", "sidebar-edit-asset-group-criticality");

        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>

<style>
.popover.wide-popover {
  max-width: 800px !important;
  width: auto !important;
}

.popover.wide-popover .popover-body {
  max-width: auto !important;
}

.popover.wide-popover .popover-body table {
  table-layout: auto !important;
}

.popover.wide-popover .popover-body td:first-child {
  width: 140px;
  white-space: nowrap;
  vertical-align: top;
}
</style>
